// extracted by mini-css-extract-plugin
export default {"mbactH1":"MbactH1_mbactH1__SqDbe"};